import React from 'react';
import ButtonCmp from 'src/components/ButtonCmp';

import checkCircle from '../../assets/img/icons/filled-icons/green-check-circle-white-icon.svg';

interface IProps {
    title: string;
    desc: string;
    isIcon?: boolean;
    type: 'success' | 'error' | 'info';
    primaryBtnText?: string;
    isShowDismissBtn?: boolean;
    isShowPrimaryBtn?: boolean;
    onPrimaryBtnClick?: () => void;
}

const sanitize = (input: string) => input.replace(/<[^>]+(on\w+|script|style)[^>]*>/g, '');

const ToastComp = ({ title, desc, type, primaryBtnText, isIcon = true, isShowDismissBtn = false, isShowPrimaryBtn = false, onPrimaryBtnClick }: IProps) => {
    const sanitizedTitle = sanitize(title);
    const sanitizedDesc = sanitize(desc);

    return (
        <div className="flex gap-2 items-center">
            {isIcon && type === 'success' && <img src={checkCircle} alt="success" className="w-[18px] max-w-[18px] h-[18px] " />}
            <div className="">
                <h2 className="text-white opacity-1 text-[14px] font-semibold leading-5" dangerouslySetInnerHTML={{ __html: sanitizedTitle }}></h2>
                <p className="text-utilityGray600 text-sm font-normal leading-tight mt-1 empty:hidden" dangerouslySetInnerHTML={{ __html: sanitizedDesc }}></p>

                {(isShowDismissBtn || isShowPrimaryBtn) && (
                    <div className="flex flex-wrap gap-x-3 mt-3">
                        {isShowDismissBtn && (
                            <ButtonCmp type="button" className="text-utilityGray700 text-sm font-semibold border-none">
                                Dismiss
                            </ButtonCmp>
                        )}

                        {isShowPrimaryBtn && (
                            <ButtonCmp
                                type="button"
                                className="btn-link-custom text-white"
                                onClick={() => {
                                    if (onPrimaryBtnClick) {
                                        onPrimaryBtnClick();
                                    }
                                }}
                            >
                                {primaryBtnText}
                            </ButtonCmp>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ToastComp;
